<template>
    <v-dialog
      v-model="showForm"
      persistent
      max-width="450"
      class="video-conference-delete-dialog"
    >
      <v-card>
        <v-card-title class="text-h5">
          <span>{{ $t('videoconf.deleteDialog.title') }}</span>
        </v-card-title>
        <br/>
        <v-card-text>
          <span>
            <span v-html="$t('videoconf.deleteDialog.message', { name: videoConference.name })"></span>
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="$emit('close')"
          >
            {{ $t('videoconf.deleteDialog.btn.cancel') }}
          </v-btn>
          <v-btn
            color="red"
            text
            class="video-conference-delete-btn"
            @click="confirmAction()"
          >
            {{ $t('videoconf.deleteDialog.btn.delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import VideoConference from 'Store/class/video_conference'

export default {
  name: 'video-conference-delete-dialog',
  props: {
    showForm: { type: Boolean, default: false },
    videoConference: { type: VideoConference, default () { return new VideoConference() } }
  },
  methods: {
    ...mapActions({
      destroy: 'videoconfer/destroy'
    }),

    confirmAction () {
      this.destroy(this.videoConference).then(() => {
        this.loading = false
        this.$emit('close')
      })
    }
  }
}
</script>

<style>
</style>
